import PaymentPage from '@pages/PaymentPage'
import PaymentFormPage from '@pages/PaymentFormPage'
import PaymentSuccessPage from '@pages/PaymentSuccessPage'
import PaymentErrorPage from '@pages/PaymentErrorPage'
import NotFoundPage from '@pages/NotFoundPage'

export default [
  {
    path: '/payin/pw',
    name: 'payment-page',
    component: PaymentPage,
    redirect: { name: 'not-found-page' },
    children: [
      {
        path: '',
        name: 'payment-form-page',
        component: PaymentFormPage,
        props: route => ({
          clientId: route.query.client_id,
          data: route.query.data,
          signature: route.query.signature,
        }),
      },
      {
        path: 'success',
        name: 'payment-success-page',
        component: PaymentSuccessPage,
      },
      {
        path: 'error',
        name: 'payment-error-page',
        component: PaymentErrorPage,
      },
      {
        path: 'not-found',
        name: 'not-found-page',
        component: NotFoundPage,
      },
      {
        path: '*',
        redirect: { name: 'not-found-page' },
      },
    ],
  },
]
